"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateMeterReadings = class CreateMeterReadings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    notes;
    irentWriteback;
    skipMetersNotFound;
    irentWritebackSkipMetersNotFound;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['notes', 'irentWriteback', 'skipMetersNotFound', 'irentWritebackSkipMetersNotFound', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                notes: null,
                irentWriteback: false,
                skipMetersNotFound: false,
                irentWritebackSkipMetersNotFound: false,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("CreateMeterReadings", "Create Meter Readings"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7804_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_register_7810_getActionArgs($event) {
        return {
            name: "resultLength",
            value: $event.data.response.data ? $event.data.response.data.length : 0,
        };
    }
    async act_1040167445267876_notification_7812_getActionArgs($event) {
        return {
            message: this.$fn.ngettext("One meter reading created.", "${n} meter readings created.", $event.data.resultLength),
        };
    }
    async act_1040167445267876_notification_7812_getWhen($event) {
        return $event.data.resultLength > 0;
    }
    async act_1040167445267876_closeModal_7814_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_7816_getActionArgs($event) {
        return {
            grid: "all",
        };
    }
    async act_1040167445267876_request_7808_getActionArgs($event) {
        return {
            operation: "create_meter_reading",
            data: this.items
                .filter(p => !!p.meter_id)
                .map(p => ({
                meter_id: p.meter_id,
                value: p.value,
                unit: p.unit,
                notes: this.notes,
                reading_type: 'automated',
                reading_date: this.$fn.formatDate(this.$fn.parseISODate(p.timestamp), 'yyyy-MM-dd'),
                reading_time: this.$fn.formatDate(this.$fn.parseISODate(p.timestamp), 'hh:mm'),
            })),
            parameters: {
                "irent-writeback": this.irentWriteback,
                "skip-meters-not-found": this.skipMetersNotFound,
                "irent-writeback-skip-meters-not-found": this.irentWritebackSkipMetersNotFound,
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7804 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7804_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7803 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7804,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7803],
        });
        const act_2248226175642056_closeComponent_7806 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_7805 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_7806,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_7805],
        });
        const act_1040167445267876_register_7810 = new core_1.actions.RegisterAction({
            actionArgs: this.act_1040167445267876_register_7810_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7809 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_register_7810,
            event: "success",
            displayName: "register",
        });
        const act_1040167445267876_notification_7812 = new core_1.actions.NotificationAction({
            actionArgs: this.act_1040167445267876_notification_7812_getActionArgs,
            when: this.act_1040167445267876_notification_7812_getWhen,
            events: [],
        });
        const evh_1040167445267876_success_7811 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_notification_7812,
            event: "success",
            displayName: "notification",
        });
        const act_1040167445267876_closeModal_7814 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_7814_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7813 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_7814,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_reloadSlickgrid_7816 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_7816_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_7815 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_7816,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_request_7808 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_7808_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_7809, evh_1040167445267876_success_7811, evh_1040167445267876_success_7813, evh_1040167445267876_success_7815],
        });
        const evh_1040167445267876_submit_7807 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_7808,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_7807],
        });
        const act_1419464017721962_closeComponent_7818 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_7817 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_7818,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_7817],
        });
        return {
            act_7315092382398562_closeModal_7804,
            evh_7315092382398562_close_7803,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_7806,
            evh_2248226175642056_close_7805,
            evh_2248226175642056_close,
            act_1040167445267876_register_7810,
            evh_1040167445267876_success_7809,
            act_1040167445267876_notification_7812,
            evh_1040167445267876_success_7811,
            act_1040167445267876_closeModal_7814,
            evh_1040167445267876_success_7813,
            act_1040167445267876_reloadSlickgrid_7816,
            evh_1040167445267876_success_7815,
            act_1040167445267876_request_7808,
            evh_1040167445267876_submit_7807,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_7818,
            evh_1419464017721962_clickPreventStop_7817,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_7808,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        default: null,
    }),
    __metadata("design:type", typeof (_a = typeof list !== "undefined" && list) === "function" ? _a : Object)
], CreateMeterReadings.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateMeterReadings.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateMeterReadings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateMeterReadings.prototype, "onSize", null);
CreateMeterReadings = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateMeterReadings);
exports.default = CreateMeterReadings;
vue_property_decorator_1.Vue.component("CreateMeterReadings", CreateMeterReadings);
